import React from 'react';
import axios from 'axios';
import { Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import Loading from "../../components/Loading/index";
import ReactQuill from 'react-quill';

class UserStoryForm extends React.Component {
  constructor(props) {
    super(props);

    this.modules = {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        [{'align': []}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
      ],
    };

    this.formats = [
      'header',
      'align',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image'
    ];

    this.state = {
      inProcess: false,
      loading: !!this.props.match.params.id,
      userStoryId: this.props.match.params.id,
      userStoryName: '',
      userStoryText: '',
      administratorName: '',
      administratorText: '',
    };

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);

    this.isValid = this.isValid.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (this.props.sessionData && this.props.sessionData.accessToken) {
      this.getUserStory();
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.sessionData && nextProps.sessionData.accessToken) {
      this.getUserStory();
    }
  }

  getUserStory() {
    if (this.props.match.params.id) {
      let loginToken = this.props.sessionData.accessToken;
      let config = {
        headers: {
          'Authorization': 'Bearer ' + loginToken
        }
      };
      axios.get(this.props.api.userStories + "/" + this.props.match.params.id, config)
        .then((response) => {
          if (!this._componentWillUnmount) {
            const data = response.data;
            this.setState({
              userStoryName: data.userStoryName,
              userStoryText: data.userStoryText,
              administratorName: data.administratorName || '',
              administratorText: data.administratorText || '',
              loading: false
            });
          }
        }).catch((error) => {
        this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst téma!');
        this.props.history.push('/userStories');
        console.log("Axios error: ", error);
      });
    }
  }

  handleChangeName(e) {
    const value = e && e.target ? e.target.value : '';
    this.setState({
      administratorName: value,
      nameError: value.trim() === '' ? 'Název tématu nesmí být prázdný!' : null,
    });
  }

  handleChangeText(value) {
    this.setState({
      administratorText: value,
      textError: value.trim() === '' ? 'Obsah tématu nesmí být prázdný!' : null,
    });
  }

  isValid () {
    const { administratorName, administratorText } = this.state;

    const validation = {
      nameError: administratorName.trim() === '' ? 'Název tématu nesmí být prázdný!' : null,
      textError: administratorText.trim() === '' ? 'Obsah tématu nesmí být prázdný!' : null,
    };

    for (const key in validation) {
      if (validation[key]) {
        this.setState({
          ...validation,
        });
        return false;
      }
    }

    return true;
  }


  handleSubmit(e) {
    e.preventDefault();

    const { userStoryId, userStoryName, userStoryText, administratorName, administratorText } = this.state;
    if (this.isValid()) {

      const values = {
        userStoryName,
        userStoryText,
        administratorName,
        administratorText,
      };

      this.setState({
        inProcess: true
      });

      this.props.action(userStoryId, values);
    }
  }

  handleClose() {
    this.props.history.push('/userStories');
  }

  render () {
    let { title, button } = this.props;
    let { userStoryName, userStoryText, administratorName, administratorText } = this.state;
    let { nameError, textError } = this.state;

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>{title}</h2>
          <div className="clearfix"/>
        </div>
        <div className="x-content">
          {
            this.state.loading ? <Loading/> :
              <Form onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="col">
                    <FormGroup controlId="name">
                      <ControlLabel>Název tématu (uživatel)</ControlLabel>
                      <FormControl
                        type="text"
                        value={userStoryName}
                        disabled
                      />
                    </FormGroup>
                    <FormGroup controlId="pointsValue">
                      <ControlLabel>Text (uživatel)</ControlLabel>
                      <FormControl
                        type="textarea"
                        value={userStoryText}
                        disabled
                      />
                    </FormGroup>
                    <FormGroup controlId="name" validationState={nameError ? 'error' : null}>
                      <ControlLabel>Název tématu (admin) <span className="required">*</span></ControlLabel>
                      <FormControl
                        type="text"
                        value={administratorName}
                        placeholder="Zadejte název tématu"
                        onChange={this.handleChangeName}
                      />
                      <FormControl.Feedback />
                      <HelpBlock>{nameError}</HelpBlock>
                    </FormGroup>
                    <FormGroup controlId="text" validationState={textError ? 'error' : null}>
                      <ControlLabel>Obsah vzdělávacího materiálu <span className="required">*</span></ControlLabel>
                      <ReactQuill
                        value={administratorText}
                        modules={this.modules}
                        formats={this.formats}
                        placeholder="Zadejte obsah tématu"
                        onChange={this.handleChangeText}
                      />
                      <HelpBlock>{textError}</HelpBlock>
                    </FormGroup>
                  </div>
                </div>
                <div className="ln-solid"/>
                <FormGroup>
                  <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-4">
                    <Button className="btn-primary" type="button" onClick={this.handleClose}>Zpět</Button>
                    <Button type="submit" disabled={this.state.inProcess} className="btn btn-success">{button}</Button>
                    {this.state.inProcess && <Loading/>}
                  </div>
                </FormGroup>
              </Form>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(UserStoryForm);



/** WEBPACK FOOTER **
 ** ./src/containers/UserStories/UserStoryForm.js
 **/